import { useCallback, useMemo, useState } from 'react';

export type OnSucceeded = (cardId: string) => void;
export type OnFailed = (error: Error) => void;
// TODO: Add the actual type for Frames/Cards when those are migrated
export const useItemsCombinedExperienceState = (items: any[]) => {
	const itemIdSet = useMemo(() => new Set(items.map((item) => item.cardId)), [items]);

	const [areAllItemsLoaded, setAreAllItemsLoaded] = useState(false);
	const [itemFailureError, setItemFailureError] = useState<Error | null>(null);

	const onItemFailed: OnFailed = useCallback((error) => {
		setItemFailureError(error);
	}, []);

	const onItemSucceeded: OnSucceeded = useCallback(
		(itemId: string) => {
			itemIdSet.delete(itemId);

			if (itemIdSet.size === 0) {
				setAreAllItemsLoaded(true);
			}
		},
		[itemIdSet],
	);

	return useMemo(
		() => ({
			areAllItemsLoaded,
			itemFailureError,
			onItemSucceeded,
			onItemFailed,
		}),
		[areAllItemsLoaded, itemFailureError, onItemSucceeded, onItemFailed],
	);
};
